import React, { useState } from "react";

import Context from "../../../../../../context";
import values from "../../../../../../values";
import {
  CustomButton2,
  CustomModal,
  CustomView,
  TableHeader,
  TableNullData,
  UserInformation,
} from "../../../../../../components";
import "./index.scss";
import { useTranslation } from "react-i18next";
import TitleLine from "../../../../../../components/TitleLine";
import convertNumberToPrice from "../../../../../../utils/convertNumberToPrice";
import utils from "../../../../../../utils";
import CarInformation from "../../../../../DriverScreen/Components/Create/Component/CarInformation";
import ShowInformation from "../../../../../ServiceScreen/Components/ShowInformation";
import convertGregorianToJalali from "../../../../../../utils/convertGregorianToJalali";

const ShowInfo = () => {
  const { showModal, setShowModal, isLoading, selected, approveFunction } =
    React.useContext(Context.DriverTransactionScreen);

  const [textArea, setTextArea] = useState<string>("");

  const { t } = useTranslation();
  console.log({ selected });

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  return (
    <section id="school-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "DRIVER_TRANSACTION_MODAL"}
        minWidth={"55rem"}
        maxHeight={"80vh"}
      >
        <CustomView.Container className="show-driver-transactin-info-container">
          <CustomView.Row className="form-row">
            <CustomView.Column>
              <UserInformation
                name={selected?.driver?.firstName}
                avatar={selected?.driver?.avatar}
                isBlock={
                  !selected?.driver?.driverInformation?.approved?.isApproved
                }
                lastName={selected?.driver?.lastName}
                phoneNumber={selected?.driver?.phoneNumber}
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <TitleLine title="لیست فاکتورها" />
            <table className="dropdown" style={{fontSize:"14px"}}>
              <TableHeader
                headers={values.tableHeaders.SHOW_INFO_DRIVER_TRANSACTION}
              />

              <>
                {(selected?.factorList.length <= 0 ||
                  !selected?.factorList) && (
                  <TableNullData text={t("driver_has_not_active_service")} />
                )}

                <tbody id="driver-table-body-container">
                  {selected?.factorList?.map((factor: any, index: number) => {
                    return (
                      <tr key={`driver-${index}`} className={"close-factor"}>
                        <td
                          className="pointer"
                          // onClick={() => onClick("driver", driver)}
                        >
                          <UserInformation
                            avatar={factor?.student?.avatar}
                            name={factor?.student?.firstName}
                            lastName={factor?.student?.lastName}
                            phoneNumber={factor?.student?.phoneNumber}
                            isBlock={factor?.student?.approved?.isApprove}
                          />
                        </td>
                        <td
                          className="pointer"
                          // onClick={() => onClick("company", driver)}
                        >
                          <UserInformation
                            name={factor?.parent?.firstName}
                            lastName={factor?.parent?.lastName}
                            phoneNumber={factor?.parent?.phoneNumber}
                            isBlock={factor?.parent?.approved?.isApprove}
                            hideAvatar
                          />
                        </td>
                        <td>
                          {utils.convertGregorianToJalali({
                            date: factor?.paidDate,
                          })}
                        </td>
                        <td
                          className="pointer"
                          // onClick={() => onClick("driver", driver)}
                        >
                          <div>{"بسته شده"}</div>
                        </td>
                        <td
                          className="pointer"
                        >
                          <div>{t(factor.payerOriginType)}</div>
                        </td>
                        <td className="pointer">
                            <div>
                              {factor?.isOnline && factor?.payerOriginType==="PASSENGER" && "اپ اولیا"}
                              {factor?.isOnline && factor?.payerOriginType==="DRIVER" && "اپ راننده"}
                              {!factor?.isOnline && "وب"}
                            </div>
                        </td>

                        <td className="pointer">
                          {factor?.price && (
                            <div>
                              {convertNumberToPrice(factor?.price)} تومان
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </>
            </table>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <TitleLine title="مشخصات واریز" />
            {(selected?.isPaid4Driver || selected?.isPaid2Driver) && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("type")} :</label>
                <p>
                  {selected?.isPaid2Driver
                    ? "پرداخت به راننده"
                    : "دریافت از راننده"}
                </p>
              </CustomView.Column>
            )}
            {selected?.withdrawalId?.amount !== undefined && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("amount")} :</label>
                <p>
                  {convertNumberToPrice(selected?.withdrawalId?.amount)}{" "}
                  {"تومان"}
                </p>
              </CustomView.Column>
            )}
            {selected?.withdrawalId?.createdAt !== undefined && (
              <CustomView.Column
                medium={5}
                small={12}
                extraLarge={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("زمان")} :</label>
                <p>
                  {convertGregorianToJalali({
                    date: selected?.withdrawalId?.createdAt,
                    format: "hh:mm - jYYYY/jMM/jDD",
                  })}
                </p>
              </CustomView.Column>
            )}
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default ShowInfo;
